module.exports = __webpack_public_path__ + "img/kassa-3-in-1.3a3b4040.png";